var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3, _rect5, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedPresenterLightHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 54,
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    fill: "#B8BBCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 30,
    height: 40,
    rx: 2,
    fill: "#F0F2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27.5C23.6406 27.5 25 26.1641 25 24.5C25 22.8594 23.6406 21.5 22 21.5C20.3359 21.5 19 22.8594 19 24.5C19 26.1641 20.3359 27.5 22 27.5ZM24.0859 28.25H23.6875C23.1719 28.5078 22.6094 28.625 22 28.625C21.3906 28.625 20.8047 28.5078 20.2891 28.25H19.8906C18.1562 28.25 16.75 29.6797 16.75 31.4141V32.375C16.75 33.0078 17.2422 33.5 17.875 33.5H26.125C26.7344 33.5 27.25 33.0078 27.25 32.375V31.4141C27.25 29.6797 25.8203 28.25 24.0859 28.25Z",
    fill: "#767676"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 7,
    width: 50,
    height: 12,
    rx: 2,
    fill: "#F0F2F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13C65.0938 13 66 12.1094 66 11C66 9.90625 65.0938 9 64 9C62.8906 9 62 9.90625 62 11C62 12.1094 62.8906 13 64 13ZM65.3906 13.5H65.125C64.7812 13.6719 64.4062 13.75 64 13.75C63.5938 13.75 63.2031 13.6719 62.8594 13.5H62.5938C61.4375 13.5 60.5 14.4531 60.5 15.6094V16.25C60.5 16.6719 60.8281 17 61.25 17H66.75C67.1562 17 67.5 16.6719 67.5 16.25V15.6094C67.5 14.4531 66.5469 13.5 65.3906 13.5Z",
    fill: "#767676"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 21,
    width: 50,
    height: 12,
    rx: 2,
    fill: "#F0F2F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 27C65.0938 27 66 26.1094 66 25C66 23.9062 65.0938 23 64 23C62.8906 23 62 23.9062 62 25C62 26.1094 62.8906 27 64 27ZM65.3906 27.5H65.125C64.7812 27.6719 64.4062 27.75 64 27.75C63.5938 27.75 63.2031 27.6719 62.8594 27.5H62.5938C61.4375 27.5 60.5 28.4531 60.5 29.6094V30.25C60.5 30.6719 60.8281 31 61.25 31H66.75C67.1562 31 67.5 30.6719 67.5 30.25V29.6094C67.5 28.4531 66.5469 27.5 65.3906 27.5Z",
    fill: "#767676"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 35,
    width: 50,
    height: 12,
    rx: 2,
    fill: "#F0F2F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41C65.0938 41 66 40.1094 66 39C66 37.9062 65.0938 37 64 37C62.8906 37 62 37.9062 62 39C62 40.1094 62.8906 41 64 41ZM65.3906 41.5H65.125C64.7812 41.6719 64.4062 41.75 64 41.75C63.5938 41.75 63.2031 41.6719 62.8594 41.5H62.5938C61.4375 41.5 60.5 42.4531 60.5 43.6094V44.25C60.5 44.6719 60.8281 45 61.25 45H66.75C67.1562 45 67.5 44.6719 67.5 44.25V43.6094C67.5 42.4531 66.5469 41.5 65.3906 41.5Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedPresenterLightHover);
export default __webpack_public_path__ + "static/media/featured-presenter-light-hover.f94c9d593.svg";
export { ForwardRef as ReactComponent };